import React, {FC} from 'react'
import {Route, RouteComponentProps, Switch, useHistory} from 'react-router-dom'

import PageLoader from '@progyny/components/PageLoader'
import {withHygraphWrapper} from '@progyny/hocs/HygraphWrapper'
import {useBenefitsGuide} from '@progyny/hooks/useBenefitsGuide'
import {RouteEnum, useRoutes} from '@progyny/routes/index'

const BenefitsGuideRoute: FC<RouteComponentProps> = ({match}) => {
  const {getPath} = useRoutes()
  const history = useHistory()

  // Use the custom hook to get benefits guide data
  // Pass 'en' as default language, or you can make it dynamic based on user's language
  const {pdfUrl, pdfLoading, pdfError} = useBenefitsGuide('en')

  if (pdfLoading) {
    return (
      <PageLoader
        position={'center'}
        loadingMessage={'You will be redirected soon'}
      />
    )
  } else if (pdfError || !pdfUrl) {
    history.push(getPath(RouteEnum.ERROR))
    return null
  } else
    return (
      <Switch>
        {pdfUrl && (
          <Route
            path={`${match.url}`}
            component={() => {
              window.location.replace(pdfUrl)
              return null
            }}
          />
        )}
      </Switch>
    )
}

export default withHygraphWrapper(BenefitsGuideRoute)
